import {
  StyledContainerColumnLeft,
  StyledContainerColumnRight,
  StyledContainerRowBetween,
} from '../../../styles/ContainerStyles'
import ScheduleDialogDescriptionBlock from '../../Schedule/ScheduleDialogDescriptionBlock'
import dayjs from 'dayjs'
import React, { Dispatch, SetStateAction } from 'react'
import { t } from 'i18next'
import { getFlexDirection, getGap } from '../../../styles/stylePropsFunctions'
import DateRangePickerWithPresets from '../../DateRangePickerWithPresets/DateRangePickerWithPresets'

type TimeFrameProps = {
  isSmallScreen: boolean
  startDate: dayjs.Dayjs | null
  setStartDate: Dispatch<SetStateAction<dayjs.Dayjs | null>>
  endDate: dayjs.Dayjs | null
  setEndDate: Dispatch<SetStateAction<dayjs.Dayjs | null>>
}

const TimeFrameSection = ({ isSmallScreen, startDate, setStartDate, endDate, setEndDate }: TimeFrameProps) => {
  return (
    <StyledContainerRowBetween
      sx={{
        gap: getGap(isSmallScreen),
        alignItems: 'flex-start',
        flexDirection: getFlexDirection(isSmallScreen),
      }}
    >
      <StyledContainerColumnLeft>
        <ScheduleDialogDescriptionBlock
          title={t('page.schedule.fillOutManyPopup.timeFrameTitle')}
          description={t('page.schedule.fillOutManyPopup.timeFrameDescription')}
        />
      </StyledContainerColumnLeft>
      <StyledContainerColumnRight sx={{ gap: 2, flexDirection: isSmallScreen ? 'row' : 'column' }}>
        <DateRangePickerWithPresets
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          column
          minDate={dayjs()}
          presetsType={'future'}
        />
      </StyledContainerColumnRight>
    </StyledContainerRowBetween>
  )
}

export default TimeFrameSection